import type { Board } from '../../../lib/api';

/** Board lists of the dashboard (P16-4): sort keys and filters, pure. Boards carry no creation date, hence no such sort. */
export type SortKey = 'edited' | 'name';
export type Filters = { archived: boolean; templates: boolean; mine: boolean };
export const DEFAULT_FILTERS: Filters = { archived: false, templates: false, mine: false };

const edited = (b: Board) => Date.parse(b.lastEditedAt ?? b.updatedAt);

export function listBoards(boards: readonly Board[], opts: { sort: SortKey; filters: Filters; userId: string; lng?: string }): Board[] {
  const { filters: f } = opts;
  const shown = boards.filter((b) => (f.archived || !b.archivedAt) && (f.templates || !b.isTemplate) && (!f.mine || b.createdBy === opts.userId));
  const byName = (a: Board, b: Board) => a.title.localeCompare(b.title, opts.lng, { sensitivity: 'base' });
  return shown.sort(opts.sort === 'name' ? byName : (a, b) => edited(b) - edited(a) || byName(a, b));
}
